import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Copyright from '../Copyright';
import TransactionDetails from './TransactionDetails';
import GraphMain from './GraphMain';
import PropTypes from 'prop-types';

export default function DetailsMainGrid({ transactionData }) {
  const [graphNodes, setGraphNodes] = React.useState([]);
  const [graphEdges, setGraphEdges] = React.useState([]);
  const [currentCenterNodeId, setCurrentCenterNodeId] = React.useState('');

  const graphContext = React.useMemo(() => ({
    currentCenterNodeId,
    totalNodes: graphNodes.length,
    totalEdges: graphEdges.length,
    visibleNodes: graphNodes.slice(0, 150),
    visibleEdges: graphEdges.slice(0, 150),
  }), [currentCenterNodeId, graphEdges, graphNodes]);

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Detalhes da Transação
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9, sm: 9 }}>
          <GraphMain
            transactionData={transactionData}
            onGraphNodesChange={setGraphNodes}
            onGraphEdgesChange={setGraphEdges}
            onCurrentCenterNodeChange={setCurrentCenterNodeId}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 3, sm: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <TransactionDetails transactionData={transactionData} graphContext={graphContext} />
          </Stack>
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}

DetailsMainGrid.propTypes = {
  transactionData: PropTypes.object,
};
